import { SET_PROFILE } from "../types/profile"

export const setProfile = profile => dispatch => {
   
    dispatch({
        type    :   SET_PROFILE,
        payload :   profile
    })
}
